// extracted by mini-css-extract-plugin
export default {"overlay":"external-layer_overlay__KvnFK"};